import React, { useMemo } from 'react';
import classnames from 'classnames';
import { getColor } from './utils';
import './Score.scss';

export function Score({ row }) {
  const score = row.user_score;

  const total = useMemo(() => {
    if(!score) {
      return null;
    }

    let result = 0;

    score.forEach(({ total_score }) => result += parseInt(total_score) || 0);

    return result;
  }, [score]);

  const totalColor = useMemo(() => {
    if(!score) {
      return null;
    }

    return total && score.length ? getColor(total / score.length) : 'none';
  }, [total, score]);

  if(!score) {
    return null;
  }

  return (
    <div className="Score">
      {score.map(({ total_score, count }, i) => {
        const color = total_score ? getColor(total_score / (count || 1)) : null;

        return (
          <div className={classnames('Score__item', 'Score__item_street', { [`Score__item_${color}`] : color })} key={i}>{total_score}</div>
        );
      })}

      <div className={classnames('Score__item', { Score__item_total : total, [`Score__item_${totalColor}`]: total && totalColor })}>{total || ''}</div>
    </div>
  );
}
